import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__string_pattern } from '../../../../_enums/ENUM__string_pattern';
import { FIELD_PRIMITIVE__base_string } from '../FIELD_PRIMITIVE__base_string';

export class FIELD_PRIMITIVE__string_hash_sha256 extends FIELD_PRIMITIVE__base_string {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_STRING_HASH_SHA256;

  /*
   * METHODS
   */
  constructor() {
    super();

    this.allowed_pattern = ENUM__string_pattern.HASH_SHA256;
    this.value_empty = ENUM__string_id_empty.HASH_SHA256;
  }
}
